import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fetchFilterData from 'api/search';
import { formatNeighborhoods } from './searchParamFormatter';

const DynamicTitle = ({ regions = [], neighborhoods = [], beds = [], pets = '' }) => {
  const [filterData, setFilterData] = useState({});

  useEffect(() => {
    fetchFilterData().then(results => {
      setFilterData(results);
    });
  }, []);

  useEffect(() => {
    try {
      let title = formatNeighborhoods(regions, neighborhoods, 'listings', filterData, beds);
      if (pets === 'all-pets-allowed') {
        title = `Pet Friendly ${title}`;
      }
      document.title = `${title} | Nooklyn`;
    } catch (error) {
      console.error('Error updating title:', error);
      document.title = 'Search apartments for rent in Brooklyn | Nooklyn';
    }
  }, [regions, neighborhoods, beds, pets, filterData]);

  return null;
};

DynamicTitle.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.string),
  neighborhoods: PropTypes.arrayOf(PropTypes.string),
  beds: PropTypes.arrayOf(PropTypes.string),
  pets: PropTypes.string,
};

DynamicTitle.defaultProps = {
  regions: [],
  neighborhoods: [],
  beds: [],
  pets: '',
};

export default DynamicTitle; 